// extracted by mini-css-extract-plugin
export default {"card":"CategoryCard_card__soNtr","iconWrap":"CategoryCard_iconWrap__JoDtV","info":"CategoryCard_info__UmClT"};